goog.provide('el8.appanalytics.ReportTab');

goog.require('el8.uiwidget.Form');


/**
 * One ReportTab per report type on page-analytics
 * (which notably doens't include the billing report).
 * It reimplements some of the same ideas as the TabbedNav widget.
 *
 * reportsMgr manages showing/displaying them.
 */
el8.appanalytics.ReportTab = function(opts) {

    opts = opts || {};

    this._trigger = opts.trigger;
    this._container = opts.container;
    this._initFn = opts.initFn;
    this._loadFn = opts.loadFn || null;
    this._formSpec = opts.formSpec || null;
    this._showOnLoad = (opts.showOnLoad !== false); // defaults true

    /* Hold State */
    this._isBusy = false;
    this._isInit = false;
    this._isLoaded = false;
};

el8.appanalytics.ReportTab.prototype._init = function() {
    this._isInit = true;
    if (this._formSpec) { 
        this._form = new el8.uiwidget.Form(this._formSpec); 
        this._form.render();
    }
    if (this._initFn) { this._initFn(); }
};

el8.appanalytics.ReportTab.prototype.show = function() {
    if (!this._isInit) { this._init(); }
    if (!this._isLoaded && this._showOnLoad) {
        this._trigger.addClass('el8TabItemSelected')
            .removeClass('el8TabItem');
        var that = this;
        that._container.show();
        this.load();
    } else {
        this._container.show();
        this._trigger.addClass('el8TabItemSelected')
            .removeClass('el8TabItem');
    }
};

el8.appanalytics.ReportTab.prototype.hide = function() {
    this._container.hide();
    this._trigger.removeClass('el8TabItemSelected')
        .addClass('el8TabItem');
};

el8.appanalytics.ReportTab.prototype.load = function(callbackFn) {

    // This method is largely here to be overloaded

    if (this._isBusy) { return false; }
    if (!this._isInit) { this._init(); }

    if (this._loadFn) {
        var that = this;
        this._isBusy = true;
        $('.report-contents', this._container).empty().addClass('feedLoading');

        this._loadFn(function() {
            if (callbackFn) { callbackFn(); }
            $('.report-contents', that._container).removeClass('feedLoading');
        }, function() {
            that._isBusy = false;
            that._isLoaded = true;
        });
    } else {
        if (callbackFn) { callbackFn(); }
    }
};

el8.appanalytics.ReportTab.prototype.setFieldVal = function(name, val) {
    if (this._form) {
        this._form.setVal(name, val);
    }
};

